import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Projeto / Convênio",
  path: "/prestacaocontas/pcoprojeto",
  name: "pcoprojeto",
  component: () => import("@/views/prestacaocontas/pcoprojeto/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.CONVENIOPROJETOSNOVO_MENU_1500100199],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Projeto / Convênio",
  path: "/prestacaocontas/pcoprojeto/cadastro/:id?",
  parent: "pcoprojeto",
  name: "pcoprojeto_create",
  component: () => import("@/views/prestacaocontas/pcoprojeto/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.CONVENIOPROJETOSNOVO_MENU_1500100199],
  },
  goesToMenu: true,
 },
]
